<p-dialog [(visible)]="display" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'"
  [styleClass]="'contextMenuModal'" [closable]="false" [dismissableMask]="true" [baseZIndex]="10000" [closeOnEscape]="true"
  [style]="{'max-width':'800px','width':'100%', 'height':'480px'}" [resizable]="false">
  <p-header>
    <div class="d-flex flex-row align-items-center justify-content-between mx-2 mt-1">
      <h6 class="gfid-title">Group Details</h6>
      <button type="button" (click)="hideModal()" class="d-flex flex-row close qma-text">
        <img src="assets/Inbox/close_icon_white.svg" alt="Close">
      </button>
    </div>
  </p-header>
  <div class="d-flex flex-row mt-4" style="padding: 12px; margin: 8px 0px 0px !important; top: 8px;">
      <ag-grid-angular  *ngIf="firstLoad" style="width:100%;" domLayout='autoHeight' class="ag-theme-balham peerTable inquiryTable groupDetailsTable"  (suppressHorizontalScroll)="true"
        [gridOptions]="gridOptions" [rowData]="rowData" [columnDefs]="columnDefs" (gridReady)="onGridReady($event)"  [rowHeight]="82"
        [headerHeight]="48" [modules]="modules">
      </ag-grid-angular>
  </div>
</p-dialog>